import React from "react";

/**
 * WorkflowFooter
 * Large, glove-friendly bottom-of-screen workflow navigation.
 * Visual: Nexora Recorder button system — mono font, gold accent on primary,
 * ghost border on back, press animation, glow on hover.
 * Props / functionality: UNCHANGED.
 */
export function WorkflowFooter({
  onBack,
  onHome,
  showBack = true,
  backLabel = "Back",
  homeLabel = "Home",
}) {
  return (
    <div className="wf-footer">
      {showBack && (
        <button
          className="wf-btn wf-btn-back"
          onClick={onBack}
          aria-label={backLabel}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          {backLabel}
        </button>
      )}

      <button
        className={`wf-btn wf-btn-home ${!showBack ? "wf-btn-home-full" : ""}`}
        onClick={onHome}
        aria-label={homeLabel}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/>
          <polyline points="9 21 9 12 15 12 15 21"/>
        </svg>
        {homeLabel}
      </button>
    </div>
  );
}
